import * as React from 'react';
import { connect } from 'react-redux';
import { IBasePageProps } from '../../../../configuration/IConfiguration';
import { bindActionCreators } from 'redux';
import { IAppState } from '../../../../../../app';
import InternalClassificationLink from '../../../../Common/Links/InternalClassificationLink';
import * as DataActionCreators from "../../../../../../actions/data.actions";
import * as DTOS from "../../../../../../FeralScan.dtos";
import { Redirect } from 'react-router';
import Loader from 'react-loaders';

interface IPageWelcomeProps {
    userPlots: DTOS.Plot[];
    userPlotsLoading: boolean;

    getUserPlots: typeof DataActionCreators.getUserPlotsRequest;
}

interface IPageWelcomeRouteParams {
}

interface IPageWelcomeQueryParams {
}

type PageWelcomeProps = IBasePageProps<IPageWelcomeRouteParams, IPageWelcomeQueryParams> & IPageWelcomeProps;

class PageWelcome extends React.Component<PageWelcomeProps, any> {
    constructor(props, context) {
        super(props, context);
    }

    componentDidMount() {
        if (!this.props.userPlotsLoading) {
            this.props.getUserPlots(false);
        }
    }

    render() {

        const loading = this.props.userPlotsLoading ? <div className="position-absolute"
            style={{ bottom: '50%', left: '42%' }}>
            <Loader type="ball-scale-multiple" active />
            <div className="ml-4 small">please wait, loading your user account</div>
        </div> : undefined

        const sitesSelectedRedirect = <Redirect to="my-data" />;

        return (
            this.props.userPlotsLoading ? loading
                : this.props.userPlots && this.props.userPlots.length > 0
                    ? sitesSelectedRedirect
                    : <div
                        className="m-lg-3 col-md-6 col-12">
                        <p>Platypus monitoring will be most worthwhile if you have a reasonably high chance of spotting an animal – say, at least one sighting recorded on average in 20 or 25 observation sessions.  There are two ways to select monitoring sites (with most persons choosing to monitor 1-3 sites, though sometimes up to 6 sites).</p>
                        <ul>
                            <li>Use an already established site. You can go to the APMN site map to find out where platypus are currently being monitored and where they have been monitored in the past. Please note that some sites (marked specially on the map) are located on private land and so are not available for general selection.</li>
                            <li>Select a new site, either on public land or your own private property.  If you would like to establish a platypus monitoring site on private land and want to limit access to yourself (or yourself and your family), APMN has been set up so this is easy to organise. </li>
                        </ul>
                        <p>Before officially registering your APMN monitoring sites (one or more), we suggest that you carry out a few trial platypus-spotting sessions to determine which location(s) will work best for you.  If you know that platypus live in a nearby river or creek but aren’t sure where you should watch for them, start by asking people in your community where platypus have been seen in the past, and then (based on this information) see if you can locate one or more places where the animals are now active. For more hints about good places to watch for these animals, see {InternalClassificationLink("choose-monitoring-site", "Choosing a Monitoring Site", undefined, undefined, undefined)}.</p>
                        {InternalClassificationLink("site-select", "Select a Site", undefined, "btn btn-primary btn-lg col-md-4 offset-md-4 col-md-4 col-12 my-4")}
                    </div>

        );
    }
}

const mapStateToProps = (state: IAppState, ownProps: PageWelcomeProps) => {

    return {
        userPlots: state.data.userPlots,
        userPlotsLoading: state.data.userPlotsLoading,
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        getUserPlots: DataActionCreators.getUserPlotsRequest
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(PageWelcome);